import React from 'react';
import { EditOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import { WrapperIconTable } from './styles';

interface IProps {
    id: number;
    to: string;
    editable?: boolean;
}

const EditButton: React.FC<IProps> = ({ id, to, editable }) => {
    return (
        <WrapperIconTable hidden={editable === false}>
            <Link
                to={`${to}/${id}`}
                style={{
                    color: 'inherit',
                    width: '100%',
                    height: '100%',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <EditOutlined size={14} />
            </Link>
        </WrapperIconTable>
    );
};

export default EditButton;
